module.exports = __webpack_public_path__ + "static/img/menuBg1.43f38ef6.png";